/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { memo, useEffect } from 'react'
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Tabs, Theme } from '@nexigendigital/nxui'
import { useDomainProductListQuery } from 'api/shop'
import { useLocalStorage } from 'helpers/hooks'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Tab {
    label: string,
    icon: object,
    render: JSX.Element
}

interface Props {
    tabs: Tab[]
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function Domains({ tabs }: Props) {
    const [tldList, setTLDList] = useLocalStorage<string[]>('tld', [])
    const { isSuccess, data } = useDomainProductListQuery(undefined, { skip: tldList.length >= 1 })

    useEffect(() => {
        if (!localStorage.getItem('tld') && isSuccess && data) {
            const tld = data.map(({ name }) => name)
            setTLDList(tld)
        }
    }, [isSuccess])

    return (
        <DomainsWrapper
            header={{ title: 'Domain Name' }}
            desc={'Search for the domain name you would like to register with your new web hosting plan.'}
            tabs={tabs}
        />
    )
}

export const MemoizedDomains = memo(Domains)

/**********************************************************************************************************
 *   STYLE
 **********************************************************************************************************/
const DomainsWrapper = styled(Tabs)`
    ${props => (Theme.Functions.mediaBreakDown(props.theme['breakpoints-xl']))} {
        margin-top: 20px
    }
`
